export default __webpack_public_path__ + "static/media/onboarding2.0443a1b9.svg";